import React from "react";
import {ActiveChat} from "./active-chat";
import {ChatSidebar} from "./sidebar";
import {Employee, Team} from "../api";
import {ConfigInterface} from "../config";
import {ChatContextProvider} from "./context/chat-context";
import {ChatMetadataContextProvider} from "./context/chat-metadata-context";

const ChatView: React.FC<{rocketChatHostname: string, employees: Employee[], teams: Team[], primaryTeam: Team|null, secondaryTeams: Team[], config: ConfigInterface}> = (props) => {
  return <div className={"max-w-(--breakpoint-2xl) p-4 mx-auto -mb-64"}>
    <div className={"flex bg-white rounded-xl shadow-lg"} style={{height: "calc(100vh - 14em)"}}>
      <ChatSidebar config={props.config} teams={props.teams} primaryTeam={props.primaryTeam} secondaryTeams={props.secondaryTeams} employees={props.employees}/>
      <ActiveChat />
    </div>
  </div>
}
export default ChatView
